import { useQuery } from '@tanstack/react-query'
import axios from 'axios'

import { convertCaseList, ConvertType } from '@/shared/utils/convertString'

export const fetchInstituteDashboards = async (
  curriculumId: string | undefined,
  userId: number | undefined,
) => {
  const resp = await axios.get(
    `${window.apiEndpoint}/my/sqna/v1/dash-boards/institute/${curriculumId}`,
    {
      headers: {
        sub: userId,
      },
    },
  )
  return convertCaseList(resp.data, ConvertType.CAMEL)
}

export const useInstituteDashboardsQuery = (
  curriculumId: string | undefined,
  userId: number | undefined,
) => {
  return useQuery({
    queryKey: ['institute-dashboards', curriculumId, userId],
    queryFn: () => fetchInstituteDashboards(curriculumId, userId),
    enabled: !!userId && !!curriculumId,
  })
}
